export {
    PaidTabs,
    type PaidTabProps,
    type PaidTabsProps
} from "./src/paid-tabs";
export { PaidTabs as default } from "./src/paid-tabs";
